/* One absolute clock for every placement. No visitor-specific storage. */
(() => {
  'use strict';
  if (customElements.get('wp-sale-countdown')) return;
  const instances = new Set();
  let config = null, signature = '', timeout = null, fixed = NaN, anchor = NaN;
  const formatters = new Map();
  function parts(time, zone) {
    if (!formatters.has(zone)) formatters.set(zone, new Intl.DateTimeFormat('en-GB', {
      timeZone: zone, year:'numeric', month:'2-digit', day:'2-digit',
      hour:'2-digit', minute:'2-digit', second:'2-digit', hourCycle:'h23'
    }));
    return Object.fromEntries(formatters.get(zone).formatToParts(new Date(time)).map(p => [p.type, p.value]));
  }
  function wallTime(p) { return Date.UTC(+p.year,+p.month-1,+p.day,+p.hour,+p.minute,+p.second); }
  // Reject invalid/gap dates. Choose the earlier instant in a fall-back overlap.
  function parseDate(value, zone) {
    try {
      const raw = String(value || '').trim().replace(' ', 'T');
      const match = raw.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?(Z|[+-]\d{2}:\d{2})?$/);
      if (!match) return NaN;
      const [,y,m,d,h,min,sec='0',offset] = match;
      const wall = Date.UTC(+y,+m-1,+d,+h,+min,+sec);
      const date = new Date(wall);
      if (date.getUTCFullYear()!==+y || date.getUTCMonth()!==+m-1 || date.getUTCDate()!==+d || +h>23 || +min>59 || +sec>59) return NaN;
      parts(wall, zone); // Always validate the configured IANA zone.
      if (offset) return Date.parse(raw);
      const candidates = [];
      for (const delta of [-36,-12,0,12,36]) {
        const sample = wall + delta * 3600000;
        const shift = wallTime(parts(sample,zone)) - sample;
        const instant = wall - shift;
        if (wallTime(parts(instant,zone)) === wall) candidates.push(instant);
      }
      return candidates.length ? Math.min(...candidates) : NaN;
    } catch (_) { return NaN; }
  }
  function deadlineAt(now) {
    if (!config || config.enabled !== true) return NaN;
    if (config.mode === 'fixed') return fixed;
    if (config.mode === 'loop') {
      const duration = (Number(config.days)*24 + Number(config.hours))*3600000;
      if (!Number.isFinite(anchor) || !Number.isFinite(duration) || duration<=0) return NaN;
      return now<anchor ? anchor : anchor + (Math.floor((now-anchor)/duration)+1)*duration;
    }
    if (config.mode === 'daily') {
      try {
        const p=parts(now,config.zone);
        const tomorrow=new Date(Date.UTC(+p.year,+p.month-1,+p.day+1));
        return parseDate(tomorrow.toISOString().slice(0,10)+' 00:00:00',config.zone);
      } catch (_) { return NaN; }
    }
    return NaN;
  }
  function configure(raw) {
    if (raw===signature) return;
    signature=raw;
    try { config=JSON.parse(raw); } catch (_) { config=null; }
    fixed=parseDate(config?.end,config?.zone);
    anchor=parseDate(config?.anchor,config?.zone);
  }
  function tick() {
    clearTimeout(timeout); timeout=null;
    const now=Date.now(), deadline=deadlineAt(now), diff=deadline-now;
    const active=Number.isFinite(diff) && diff>0;
    let visible=false;
    for (const el of instances) {
      el.hidden=!active || el.dataset.enabled==='false';
      if (el.dataset.placement === 'header') el.style.display = el.hidden ? 'none' : 'contents';
      if (el.hidden) continue;
      visible=true;
      const total=Math.ceil(diff/1000);
      const values={days:Math.floor(total/86400),hours:el.dataset.days==='true'?Math.floor(total/3600)%24:Math.floor(total/3600),minutes:Math.floor(total/60)%60,seconds:total%60};
      for (const [unit,value] of Object.entries(values)) {
        const node=el.querySelector(el.dataset.placement === 'header' ? '.'+unit : '.wpct-'+unit);
        if(node) node.textContent=String(value).padStart(2,'0');
      }
    }
    if (active && visible) timeout=setTimeout(tick,1000-Date.now()%1000);
  }
  class SaleCountdown extends HTMLElement {
    static get observedAttributes() { return ['data-timing','data-days','data-enabled']; }
    connectedCallback() { instances.add(this); configure(this.dataset.timing); tick(); }
    disconnectedCallback() { instances.delete(this); if(!instances.size) { clearTimeout(timeout); timeout=null; } }
    attributeChangedCallback(name) { if(!this.isConnected) return; if(name==='data-timing') configure(this.dataset.timing); tick(); }
  }
  customElements.define('wp-sale-countdown',SaleCountdown);
})();
